import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';

interface StoreSummaryAccessDeniedProps {
  onBack: () => void;
}

const StoreSummaryAccessDenied: React.FC<StoreSummaryAccessDeniedProps> = ({ onBack }) => (
  <Box sx={{ p: 3 }}>
    <Paper
      elevation={0}
      sx={{
        p: 6,
        textAlign: 'center',
        color: 'text.primary',
        borderRadius: 3,
        maxWidth: 600,
        mx: 'auto',
        mt: 8,
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Typography variant="h1" sx={{ fontSize: 80, mb: 2 }}>
          🚫
        </Typography>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
          Access Denied
        </Typography>
        <Typography variant="h6" sx={{ opacity: 0.9, mb: 3 }}>
          Super admin privileges required
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.8 }}>
          You don&apos;t have the necessary permissions to view store summary data.
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="large"
        onClick={onBack}
        sx={{
          background: '#2C6CA0',
          color: 'white',
          px: 4,
          py: 1.5,
          '&:hover': {
            background: '#2C6CA0',
          },
        }}
      >
        Go to Scratchers
      </Button>
    </Paper>
  </Box>
);

export default React.memo(StoreSummaryAccessDenied);
